import { RESIDENCE_ENUM } from '../../../utils/capitalUtils';

export function matchedResidenceEnum(strOrInt) {
  // either user submit a string or Int, but the final result must be Int
  const matchedResidence = RESIDENCE_ENUM.filter(residenceEnum => {
    return residenceEnum.id === strOrInt || residenceEnum.name === strOrInt;
  })[0];

  if (matchedResidence) return matchedResidence.id;
  throw new Error('form.residenceOwnership does not match any enum');
}

export function matchedBusinessCategoryEnum(strOrInt, BUSINESS_CATEGORY_ENUM) {
  // either user submit a string or Int, but the final result must be Int

  if (!BUSINESS_CATEGORY_ENUM)
    throw new Error(
      'Business category enum is nil, check if fetch https://www.mokapos.com/get_all_business_categories is success'
    );

  const _matchedBusinessCategory = BUSINESS_CATEGORY_ENUM.filter(
    residenceEnum => {
      return residenceEnum.id === strOrInt || residenceEnum.name === strOrInt;
    }
  )[0];

  if (_matchedBusinessCategory) return _matchedBusinessCategory.id;
  throw new Error('form.business_category does not match any enum');
}
